import { render, staticRenderFns } from "./LeaveButton.vue?vue&type=template&id=9341cef8&scoped=true&"
import script from "./LeaveButton.vue?vue&type=script&lang=js&"
export * from "./LeaveButton.vue?vue&type=script&lang=js&"
import style0 from "./LeaveButton.vue?vue&type=style&index=0&id=9341cef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9341cef8",
  null
  
)

export default component.exports